// © Thibault Sabathier, 2025. Tous droits réservés.
// frontend/src/services/interestsService.js
// Wrapper API centres d'intérêt. Les endpoints backend renvoient { success, data } ;
// on retourne directement `data` aux composants.

import { get, put } from '../utils/apiClient'

const BASE = '/interests'
const unwrap = (res) => (res && res.data !== undefined ? res.data : res)

// La taxonomie est statique → cache mémoire pour éviter un appel par montage
// (InterestsEditor + chaque ouverture de fiche). Non caché si l'appel échoue.
let taxonomyCache = null

const interestsService = {
  // Taxonomie canonique pour l'autocomplete groupé : { categories, interests }.
  async getTaxonomy() {
    if (taxonomyCache) return taxonomyCache
    const data = unwrap(await get(`${BASE}/taxonomy`))
    if (data) taxonomyCache = data
    return data
  },

  // Mes centres d'intérêt : [{ id, slug, label, category }].
  async getMyInterests() {
    return unwrap(await get(`${BASE}/me`))
  },

  // Remplace l'ensemble de mes centres d'intérêt (labels). Renvoie la nouvelle liste.
  async setMyInterests(labels) {
    return unwrap(await put(`${BASE}/me`, { interests: Array.isArray(labels) ? labels : [] }))
  },

  // Centres d'intérêt d'un autre membre (affichage fiche).
  async getMemberInterests(memberId) {
    return unwrap(await get(`${BASE}/member/${memberId}`))
  },

  // Intérêts en commun avec un autre membre.
  async getCommonInterests(memberId) {
    return unwrap(await get(`${BASE}/member/${memberId}/common`))
  },

  // IDs des membres ayant un intérêt (filtre annuaire). Renvoie number[].
  async getMembersByInterest(slug) {
    if (!slug) return []
    return unwrap(await get(`${BASE}/members`, { params: { slug } }))
  },
}

export default interestsService
